import cn from 'bem-cn';
import { Achievement } from '@ai-platform/utils';

import { Stack } from '../UI';

import { AchievementCard, AchievementCardSkeleton } from './AchievementCard';
import { AchievementCardListProps } from './AchievementList.types';
import './AchievementList.scss';

const b = cn('achievement-list');

const renderAchievementSkeleton = (_: unknown, index: number) => {
    return <AchievementCardSkeleton key={`achievement-skeleton-${index}`} />;
};

const renderAchievement = (keyring: Achievement) => {
    return <AchievementCard key={keyring.id} achievement={keyring} />;
};

export const AchievementList = (props: AchievementCardListProps) => {
    const { achievements, isLoading } = props;

    return (
        <Stack className={b()}>
            {isLoading ? Array.from({ length: 12 }, renderAchievementSkeleton) : achievements?.map(renderAchievement)}
        </Stack>
    );
};
